window.addEventListener('DOMContentLoaded', function() {
  (function( $ ) {
  
		function update_add_to_cart_button_text ()
		{
			if (typeof variant_info === 'undefined')
			{
				return;
			}

			var is_updated = false;
			var options = {
				"option1" : "NOOPTION",
				"option2" : "NOOPTION",
				"option3" : "NOOPTION"
			};
			var add_to_cart_button = $("#AddToCart-product-template");
			for(var i = 1; i <= 3; i++)
			{
				$(".single-option-selector-product-template[data-index='option"+i+"']").each(function( index )
				{
					if ($(this).is(':checked'))
					{
						options["option"+1] = $(this).val();
					}
				});
			}
			for (var i in variant_info)
			{
				if (options["option1"] == variant_info[i]["option1"] && options["option2"] == variant_info[i]["option2"] && options["option3"] == variant_info[i]["option3"])
				{
					is_updated = true;
					add_to_cart_button.html(variant_info[i]["button_text"]);
				}
			}
			if (is_updated == false)
			{
				add_to_cart_button.html(default_add_to_cart_text);
			}		
		}

		var waitForEl = function(selector, callback) {
			if (!jQuery(selector).length) {
				setTimeout(function() {
					window.requestAnimationFrame(function(){ waitForEl(selector, callback) });
				}, 100);
			} else {
				callback();
			}
		};
		
        var product_variation_count = jQuery('.selection-wrapper.variant select#ProductSelect-product-template').children('option').length;
          var passed_first = false;
          jQuery(".product-image--cell").each(function() {
            if(jQuery(this).is(":visible"))
            {
              if (passed_first == false)
              {
                passed_first = true
              }
              else
              {
                jQuery(this).addClass("grid_image");
              }
            }
          });
		/* Start Reward page Pop Up open click by banner Script */
		jQuery(document).ready(function(){	
			adjustHeightBestOfSevenCarousel();

		  	jQuery(".page-reward-banner, .reward-invite-friend-item-banner, .reward-redeemable-rewards-point-button").click(function(){
		    	waitForEl('.smile-launcher-frame', function() {
		      		jQuery('.smile-launcher-frame').contents().find('button.launcher-button').click();
		    	});
		  	});
		});
		/* End Reward page Pop Up open click by banner Script */

		/* Start Group Product Script */
		jQuery(".fc_custom_select_option").change(function(){
		  window.location.replace(jQuery(this).val());
		});
		/* End Group Product Script */

		/* Start Tab Script */
		var instance = M.Tabs.init(document.querySelectorAll('.mz-product-tabs'));
		var instance = M.Tabs.init(document.querySelectorAll('.mz-product-salespoint-tabs'));
    	var instance = M.Tabs.init(document.querySelectorAll('.mz-product-icon-tabs'));
    	var instance = M.Tabs.init(document.querySelectorAll('.mz-product-description-tabs'));
    	var instance_tab_quiz = M.Tabs.init(document.querySelectorAll('.mz-skin-type-quiz-tabs'));
		/* End Tab Script */

        /*
		jQuery("#AddToCart-product-template").click(function(){	
          ttq.track('AddToCart', {
            content_id: $("#ProductSelect-product-template").attr("data-productid"),
            content_type: 'product',
            content_name: $("h1").html().trim(),
            quantity: 1,
            price: $("#ProductPrice-product-template").html().replace("$", ""),
            value: $("#ProductPrice-product-template").html().replace("$", ""),
            currency: 'USD',
          });
		});

    	jQuery(".checkout-buttons input[name*='checkout']").click(function(){
          ttq.track('InitiateCheckout');
        });
        */
    
    	/* Variation title change starts # Added by TW */
    	async function switchProductTitleByVariation(_str)
        {
          if (_str == undefined)
          {
	          jQuery(".product-title h1").html(product_title);
          }
          else
          {
	          jQuery(".product-title h1").html(product_title+" - "+_str);
          }
        }
    	async function switchProductSalespointByVariation(_str)
        {
          if($('.mz-product-salespoint-tabs').length > 0)
          {
            var instance_salespoint_tab = M.Tabs.getInstance(document.getElementsByClassName("mz-product-salespoint-tabs")[0]);
            instance_salespoint_tab.select('product_salespoint_'+_str);
          }
        }
    	async function switchProductIconByVariation(_str)
        {
          if($('.mz-product-icon-tabs').length > 0)
          {
            var instance_icon_tab = M.Tabs.getInstance(document.getElementsByClassName("mz-product-icon-tabs")[0]);
            instance_icon_tab.select('product_icon_'+_str);
          }
        }
    	async function switchProductDescriptionByVariation(_str)
        {
          if($('.mz-product-description-tabs').length > 0)
          {
            var instance_description_tab = M.Tabs.getInstance(document.getElementsByClassName("mz-product-description-tabs")[0]);
            instance_description_tab.select('product_description_'+_str);
          }
        }

    	if (document.getElementsByTagName("body")[0].getAttribute("data-template") == "product")
        {
          var selected_variant_id = null, product_title = null;

          jQuery(document).ready(function(){
            product_title = jQuery(".product-title h1").html().trim();
            selected_variant_id = jQuery(".selection-wrapper.variant select#ProductSelect-product-template").val();
            switchProductTitleByVariation(jQuery('.selection-wrapper.variant input[type="radio"]:checked').val());
            switchProductIconByVariation(selected_variant_id);
            switchProductSalespointByVariation(selected_variant_id);
            switchProductDescriptionByVariation(selected_variant_id);
          });

          jQuery(".swatch-container").click(function(){
            selected_variant_id = jQuery(".selection-wrapper.variant select#ProductSelect-product-template").val();
            var variant_list = document.getElementById('ProductSelect-product-template'), i, variant_name;

            for(i = 0; i < variant_list.length; i++)
            {
              variant_name = variant_list[i].text.split(" - $")[0].trim();
              if (variant_name == jQuery('.selection-wrapper.variant input[type="radio"]:checked').val())
              {
                selected_variant_id = variant_list[i].value;
              }
            }
            switchProductTitleByVariation(jQuery('.selection-wrapper.variant input[type="radio"]:checked').val());
            switchProductIconByVariation(selected_variant_id);
            switchProductSalespointByVariation(selected_variant_id);
            switchProductDescriptionByVariation(selected_variant_id);
          });
        }
    	/* Variation title change end */
    
        /* Adjust Smile.io for CCPA end */
		jQuery(document).ready(function(){
          setInterval(function(){
            jQuery("#smile-ui-container").removeAttr('style');
            jQuery("#smile-ui-container").css({ 'z-index' : '2147483646 !important', 'position': 'fixed', 'width': '0px', 'height': '0px', 'bottom': '0px', 'right': '0px'});
          }, 100);
		});
        /* Adjust Smile.io for CCPA end */

    
		/* Start Collapsible Script */
		var instance = M.Collapsible.init(document.querySelectorAll('.collapsible'));
		/* End Tab Script */

		/* Start Carousel Script */
		var instance = M.Carousel.init(document.querySelectorAll('.mz-fullwidth-carousel'), { fullWidth: true, indicators:true });
		var instance = M.Carousel.init(document.querySelectorAll('.mz-carousel', { indicators:true }));
		/* End Carousel Script */

		window.onload = window.onresize = function () {
			adjustHeightBestOfSevenCarousel();
		}

		function adjustHeightBestOfSevenCarousel()
		{
		    var height = parseInt(document.documentElement.clientWidth);
		    if (height <= 320)
		    {
		    	height = 1800;
		    }
		    else if (height > 320 && height <= 720)
		    {
		    	height = 1800 + 1800 * ((height-320)/400);
			    /*
					Mobile
					320 x 1800
					720 x 3600		    
			    */
		    }
		    else if (height >= 721 && height <= 1080)
		    {
		    	height = 1950 + 800 * ((height-720)/360);
			    /*
					Desktop
					721 X 1950
					1080 X 2750
			    */
		    }
		    else
		    {
		    	height = 2750;
		    }
		    $(".what-it-is-tab-carousel .carousel").height(height);		
		}


		$('.site-footer .box-1 ul li:last-of-type').click(function(event) {
			event.preventDefault();
			$('.acsb-trigger').click();
		});

		$('body').on('DOMSubtreeModified', '#ProductPrice-product-template', function(){
			if($('afterpay-placement').length > 0)
			{
				var new_price = document.getElementById("ProductPrice-product-template").getAttribute("data-currency-usd");
				if (new_price != null)
				{
					new_price = new_price.replace("USD", "").replace("$", "").trim();
					document.getElementsByTagName("afterpay-placement")[0].setAttribute("data-amount", new_price);
				}
			}			
		});

		$(".single-option-selector-product-template").click(function(){
			update_add_to_cart_button_text();
		});

		var screen_view = "";
		jQuery(document).ready(function(){
			update_add_to_cart_button_text();
			updateSlideVideo();
		});

	  jQuery(window).resize(function(){
			updateSlideVideo();
	  });

	  function updateSlideVideo()
	  {
	    var video_elem = document.getElementById("home-hero-video");

	    if(typeof(video_elem) == 'undefined' || video_elem == null)
	    {
        return;
	    }

  		var current_screen_view = null;
      if (jQuery( window ).width() > 720)
      {
	  		var current_screen_view = "desktop";
      }
      else
      {
	  		var current_screen_view = "mobile";
      }
      if (screen_view != current_screen_view)
      {
      	screen_view = current_screen_view;
				if (current_screen_view == "desktop")
				{
				  document.getElementById("home-hero-video").src = "https://player.vimeo.com/video/642521861?background=true&api=1&player_id=home-hero-video";
					$(".fluid-width-video-wrapper").css("padding-top", "56%");
				}
				else
				{
				  document.getElementById("home-hero-video").src = "https://player.vimeo.com/video/643601116?background=true&api=1&player_id=home-hero-video";
					$(".fluid-width-video-wrapper").css("padding-top", "100%");
				}
      }
	  }




  	/* Skin Type Quiz Start */
  	$(".skin-type-quiz-intro-start-button").click(function(){
        initQuiz();
      });

      $(".skin-type-quiz-question-block-choice").click(function(){
        if ($(this).children("input").attr('type') == "radio")
        {
          $(this).parent().parent().children(".col").each(function() {
            $(this).children(".skin-type-quiz-question-block-choice").removeClass("selected");
          });
        }

        if ($(this).children("input").is(":checked"))
        {
          $(this).children("input").prop("checked",false);
        }
        else
        {
          $(this).children("input").prop("checked",true);
          $(this).addClass("selected");
        }
      });

      var current_step = 1;
      var max_step = 8;

    	function initQuiz()
        {
          $(".skin-type-quiz-intro").hide();
          $(".skin-type-quiz-body").show();

          $(".mz-skin-type-quiz-tabs li.col").each(function(index) {
            if(index !== 0 && $(this).hasClass( "disabled" ) == false)
            {
              $(this).addClass("disabled");
            }
          });

          $(".skin-type-quiz-question-block-choice.selected").each(function(){
              $(this).removeClass("selected");
          });
          
          $( ".question-input:checked" ).each(function() {
            $(this).prop("checked",false);
          });

          setStep(1);
        }

        function setStep(index)
        {
          if (index == current_step)
          {
            return;
          }
          
          $(".step"+current_step).addClass("step"+index).removeClass("step"+current_step);

          if ($(".question-tabs-header-item.header-"+(index)).hasClass("disabled"))
          {
            $(".question-tabs-header-item.header-"+(index)).removeClass("disabled");
          }
          var el = document.getElementsByClassName("tabs")[0];
          var _instance_tab_quiz = M.Tabs.getInstance(el);
          _instance_tab_quiz.select('skin-type-quiz-q'+(index));

          current_step = index;

          if (current_step == max_step)
          {
            bindQuestionResult();
	    	var instance_tab_quiz_login = M.Tabs.init(document.querySelectorAll('.mz-skin-type-quiz-login-tabs'));
            if ($(".question-form-email").val() != "")
            {
              storeMeta();
            }
          }
        }

		$(".log-in-form-submit").click(function(){
		  var datas = $('#customer_login').serialize();
		  $.ajax({
		    type: 'post',
		    url: '/account/login',
		    data: datas,
		    dataType: 'html',
		    async: true,
		    success: function (response) {
				$("#login .result-message").html("");
				var result = $(response);
				console.log($('#CustomerLoginForm .errors', result).html());
				var msg = $('#CustomerLoginForm .errors ul li', result).html();
				if (msg != null)
				{
					$("#skin-type-quiz-login .result-message").html("<i class='fa fa-exclamation-circle' aria-hidden='true'></i> "+msg);
					return;
				}
				$(".question-form-email").val($("#customer_login_email").val());

				storeMeta();
				if ($(".skin-type-quiz-result").hasClass("hide-result"))
				{
					$(".skin-type-quiz-result").removeClass("hide-result");
				}
		   },
		    error: function(response)
		    {
		      $('#customer_login').append("<input type='hidden' name='checkout_url' value='/pages/question?type="+getQuestionResult()+"'>");
		      $('#customer_login').submit();
		    }
		  });
		});

		$(".register-form-submit").click(function(){
		  var datas = $('#create_customer').serialize();
		  $.ajax({
		    type: 'post',
		    url: 'https://app.facetory.com/api/account/create',
		    data: datas,
		    success: function (response) {
		    	console.log(response);
		      $("#register .result-message").html("");
		      if (response.error == true)
		      {
		        for (var index in response.data)
		        {
		          if ($("#register .result-message").html() != "")
		          {
		            $("#register .result-message").append("<br>");
		          }
		          $("#skin-type-quiz-register .result-message").append("<i class='fa fa-exclamation-circle' aria-hidden='true'></i> "+response.data[index].replace("base ", ""));
		        }
		        return;
		      }
		      $(".question-form-email").val($("#customer_email").val());
		      storeMeta();
		      if ($(".skin-type-quiz-result").hasClass("hide-result"))
		      {
		        $(".skin-type-quiz-result").removeClass("hide-result");
		      }
		    }
		  });
		});
    
		function storeMeta()
		{
			console.log(getQuestionValues());
			var datas = {
				email: $(".question-form-email").val(),
				data: getQuestionValues(),
				skin_type: getQuestionResult()
			};

			$.ajax({
				type: 'post',
				url: 'https://app.facetory.com/api/account/meta/store',
				data: datas,
					success: function (response) {
				},
					error: function(response) {
				}
			});
		}

		var getUrlParameter = function getUrlParameter(sParam) {
		    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
		        sURLVariables = sPageURL.split('&'),
		        sParameterName,
		        i;

		    for (i = 0; i < sURLVariables.length; i++) {
		        sParameterName = sURLVariables[i].split('=');

		        if (sParameterName[0] === sParam) {
		            return sParameterName[1] === undefined ? true : sParameterName[1];
		        }
		    }
		};

		function getQuestionValues()
		{
		  var answer = {};
		  var type = {};

		  $( ".question-input:checked" ).each(function() {
		    if (answer[$( this ).attr("name")] === undefined)
		    {
		      answer[$( this ).attr("name")] = "";
		    }
		    if (answer[$( this ).attr("name")] != "")
		    {
		      answer[$( this ).attr("name")] += ",";
		    }
		    answer[$( this ).attr("name")] += $( this ).val();
		    
		    if ($( this ).attr("data-type") != undefined)
		    {
		      if (type[$( this ).attr("name")] === undefined)
		      {
		        type[$( this ).attr("name")] = "";
		      }

		      if (type[$( this ).attr("name")] != "")
		      {
		        type[$( this ).attr("name")] += ",";
		      }
		      type[$( this ).attr("name")] += $( this ).attr("data-type");
		    }
		  });
		  
		  return { answer: answer, answer_type: type };
		}

		function bindQuestionResult(type)
		{
			var result;
			var target_obj = $(".skin-type-quiz-result");
			target_obj.removeClass("result-oily");
			target_obj.removeClass("result-dry");
			target_obj.removeClass("result-combo");
			target_obj.removeClass("result-normal");

			if(type != undefined)
			{
				result = type;
				setStep(max_step);
			}
			else
			{
				result = getQuestionResult();
				if (result == undefined)
				{
					result = "normal";
				}
			}
			target_obj.addClass("result-"+result);
			$(".skin-type-quiz-body").hide();
			$(".skin-type-quiz-result").show();
		}

		function getQuestionResult()
		{
			var skin_type_counter = {dry: 0, normal: 0, combo: 0, oily: 0};
			var answer, i, max_index, max = -1;

			for(i = 4; i < 8; i++)
			{
				var answer = $("input[name='q"+i+"']:checked").attr("data-type");
				if (answer == null)
				{
					continue;
				}
				var answer_list = answer.split("|");
				answer_list.forEach(function(answer_item) {
					switch(answer_item) {
					  case "dry":
					  	skin_type_counter.dry++;
					    break;
					  case "normal":
					  	skin_type_counter.normal++;
					    break;
					  case "combo":
					  	skin_type_counter.combo++;
					    break;
					  case "oily":
					  	skin_type_counter.oily++;
					    break;
					  default:
					    break;
					}
				});
			}

			Object.keys(skin_type_counter).forEach(function (index){
				if (skin_type_counter[index] > max)
				{
					max = skin_type_counter[index];
					max_index = index;
				}
				else if (skin_type_counter[index] == max)
				{
					max_index = max_index+","+index;
				}
			});

			if (max_index.includes(",") == true)
			{
				return "combo";
			}
			else
			{
				return max_index;
			}
		}


        $(".skin-type-quiz-back-button").click(function(){
          window.location.href = "/";
        });    	

    	$(".skin-type-quiz-prev").click(function(){
          if (current_step <= 1)
          {
            return;
          }
          setStep(current_step-1);
        });    	

    	$(".skin-type-quiz-next").click(function(){
          if (current_step >= max_step)
          {
            return;
          }
          if(current_step < 8 && !$("input[name='q"+current_step+"']:checked").is(':checked'))
          {
            alert("Please Select One of the option.");
            return;
          }
          setStep(current_step+1);
        });
    	/* Skin Type Quiz End */

        /* Address Change Pop up Start */
        $(".address_update_button, .address_edit.popup_overlay .close_popup").click(function(){
          $(".address_edit.popup_overlay").toggle();
        })    
        /* Address Change Pop up End */
  })(jq223);
});
